import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { CompanyStatsBarComponent } from './company-stats-bar';
import { ComponentsModule } from '../components.module';
import {NgPipesModule} from 'ngx-pipes';

@NgModule({
  declarations: [
    CompanyStatsBarComponent,
  ],
  imports: [
    IonicModule,
    NgPipesModule,
  ],
  exports: [
    CompanyStatsBarComponent,
    ComponentsModule
  ]
})
export class CompanyStatsBarComponentModule {}



// WEBPACK FOOTER //
// ./src/components/company-stats-bar/company-stats-bar.module.ts